<body class="nex-body">
  @if (loggedIn) {
    <app-header></app-header>
  }
  <main class="mainContainer">
    <ngx-spinner class="loading-spinner" color="#111111" type="ball-spin-clockwise" size="large" fullScreen="true" bdColor="rgba(51,51,51,0.5)"></ngx-spinner>
    @if (!isIframe) {
      <router-outlet></router-outlet>
    }
  </main>
  @if (loggedIn) {
    <app-footer></app-footer>
  }
</body>
